import type { Dtos } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { sfaaClassExperienceFiltersQueryKey } from "../sfaa-class-experience.keys";

export const useFetchSfaaClassExperienceFilters = () => {
	const { get } = useRequest();

	return useQuery({
		queryKey: sfaaClassExperienceFiltersQueryKey(),
		queryFn: async () =>
			await get<Dtos.Admin.SfaaClassExperience.Filters.Response>(
				"/v2/admin/surety/sfaa-class-experience/filters",
			),
	});
};
